import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Avatar, CircularProgress } from '@mui/material';
import axios from 'axios';
import { getBackendUserUrl } from '../../utils/utils';

const TeamPanel = ({ eventId }) => {
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchGroupsAndMembers = async () => {
            setLoading(true);
            setError(null);
            try {
                // Fetch assignment groups
                const groupsRes = await axios.get(`${getBackendUserUrl()}/agenda/assignment_groups/${eventId}`);
                const groupsData = groupsRes.data || [];
                // For each group, fetch its members
                const groupsWithMembers = await Promise.all(
                    groupsData.map(async (group) => {
                        try {
                            const membersRes = await axios.get(`${getBackendUserUrl()}/agenda/assignment_group_members/${group.assignmentGroupId}`);
                            return { ...group, members: membersRes.data || [] };
                        } catch {
                            return { ...group, members: [] };
                        }
                    })
                );
                setGroups(groupsWithMembers);
            } catch (err) {
                setError('Failed to load team groups');
            } finally {
                setLoading(false);
            }
        };
        if (eventId) fetchGroupsAndMembers();
    }, [eventId]);

    if (loading) {
        return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 120 }}><CircularProgress /></Box>;
    }
    if (error) {
        return <Typography color="error">{error}</Typography>;
    }
    if (!groups.length) {
        return <Typography>No team groups found.</Typography>;
    }

    return (
        <TableContainer component={Paper}>
            <Table size="small" stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell>Team Group</TableCell>
                        <TableCell>Members</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {groups.map(group => (
                        <TableRow key={group.assignmentGroupId || group.name}>
                            <TableCell sx={{ fontWeight: 600 }}>{group.name}</TableCell>
                            <TableCell>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                                    {group.members.length === 0 ? (
                                        <Typography variant="body2" color="text.secondary">No members</Typography>
                                    ) : (
                                        group.members.map(member => (
                                            <Box key={member.userId} sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
                                                {member.User?.avatarUrl && (
                                                    <Avatar src={member.User.avatarUrl} alt={member.User.firstName} sx={{ width: 28, height: 28, mr: 1 }} />
                                                )}
                                                <Typography variant="body2">
                                                    {member.User ? `${member.User.firstName} ${member.User.lastName}` : member.userId}
                                                </Typography>
                                            </Box>
                                        ))
                                    )}
                                </Box>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default TeamPanel; 